import React from 'react';
import { SUPPORT_EMAIL, INSTAGRAM } from '../lib/config';
export function Footer() {
  return <footer className="w-full border-t border-gold-soft bg-ivory py-14" data-id="element-112" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-113" data-mp="32nukolv2nz0b">
        <p className="font-serif text-2xl text-ink" data-id="element-114" data-mp="32pfeg99kbdx4">Wedding Pro OS™</p>
        <div className="rule-gold mx-auto mt-6 w-24" aria-hidden="true" data-id="element-115" data-mp="36oo9rik93jus" />
        <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-ink-soft" data-id="element-116" data-mp="3uf0md6qfy4rp">
          El sistema operativo completo para las wedding planners que se cansaron de dar
          precio de amiga.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-ink-soft" data-id="element-117" data-mp="3levi35gjnmhr">
          <li data-id="element-118" data-mp="3qcdsl0a7m9rv">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors hover:text-gold-dark" data-id="element-119" data-mp="3qc3z32pyhkhf">
              {SUPPORT_EMAIL}
            </a>
          </li>
          <li data-id="element-120" data-mp="2ez1nyn6mln4n">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-121" data-mp="2ezl4bzgmo3gk">
              {INSTAGRAM}
            </a>
          </li>
          <li data-id="element-122" data-mp="3gah29wtj3p7f">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-123" data-mp="3gaz1n2bhmjjk">
              Términos y condiciones
            </a>
          </li>
          <li data-id="element-124" data-mp="3v919hopjxr6m">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-125" data-mp="3v5n6ce92ddy4">
              Política de privacidad
            </a>
          </li>
        </ul>

        <p className="mt-10 text-[11px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-126" data-mp="81yx4j0q5y3z">
          © 2026 Wedding Pro OS™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}